import { Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../../../design-system/button/button.component';
import { ButtonConfig } from '../../../design-system/button/button.modal';


@Component({
    selector: 'new-formly-button',
    templateUrl: "./new-formly-button.component.html",
    standalone: true,
    imports: [CommonModule, ButtonComponent]
})

export class FormlyNewButtonComponent extends FieldType implements OnInit, OnDestroy {
    param: any;
    isFormSubmitted: boolean = false;
    formSubmissionSubscription: Subscription;
    fieldKey: string;
    label: string;
    buttonClass: string;
    iconClass: string;
    showAdvancePassbookPanel: boolean = false; // when this is true then advance passbook panel will open
    currencyCode: string="";
    constructor(private dynamicFormService: DynamicFormService) {
        super();
    }

    buttonConfig: ButtonConfig = {
        label: '',
    };

    ngOnInit() {
        if (this.field.key) {
            this.fieldKey =this.field.id??this.field.key.toString();
            this.buttonConfig.id = this.fieldKey;      
        }
        if (this.field.templateOptions && this.field.templateOptions.label) {
            this.label = this.field.templateOptions.label;
            this.buttonConfig.label = this.label;
        }
        if (this.field.templateOptions && this.field.templateOptions.buttonClass) {
            this.buttonClass = this.field.templateOptions.buttonClass;
        }
        if (this.field.templateOptions && this.field.templateOptions.iconClass) {
            this.iconClass = this.field.templateOptions.iconClass;
        }
        this.buttonConfig={...this.buttonConfig,
            iconPosition: this.field.props?.iconPosition,
            icon: this.field.props?.icon,
            color: this.field.props?.color,
            size: this.field.props?.size
        }
        this.formSubmissionSubscription = this.dynamicFormService.getFormSubmittedEvent().subscribe(data => {
            this.isFormSubmitted = data;
        });
    }

    ngOnDestroy() {
        if (this.formSubmissionSubscription) {
            this.formSubmissionSubscription.unsubscribe();
        }
    }

    onClick() {
        this.to.click(this.field);
        if(this.field?.props?.showAdvancePassbookPanel === true) {
            this.showAdvancePassbook();
        }
    }

    showAdvancePassbook() {
        this.showAdvancePassbookPanel = true;
        this.currencyCode = this.model.currencyCode;
    }

    closeAdvancePassbookPanel() {
        this.showAdvancePassbookPanel = false;
    }

}
